import { Box, Typography } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import moment from "moment";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import React, { useRef } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const dateFormats = [
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  moment.ISO_8601,
];

const formatDate = (date) => {
  if (!date) return "";
  const parsedDate = moment(date, dateFormats, true);
  if (parsedDate.isValid()) return parsedDate.format("DD/MM/YYYY");
  const fallbackDate = moment(date);
  return fallbackDate.isValid() ? fallbackDate.format("DD/MM/YYYY") : date;
};

export const ReportDateRangeFilter = ({
  startDate,
  endDate,
  handleStartDate,
  showToday = false,
  triggerDate = true,
  includeCurrentDate = false,
  allowFutureDate = false,
  fromDate,
  toDate,
  children,
}) => {
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  return (
    <Box
      sx={{
        border: "1px solid #00D4AA",
        borderRadius: "8px",
        px: 1.5,
        py: 0,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f5f7fa",
        height: 40,
        boxSizing: "border-box",
        gap: 0.5,
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        width: "100%",
      }}
    >
      <DateRangeIcon
        sx={{
          color: "#7c98b6",
          fontSize: 18,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: "#7c98b6",
          whiteSpace: "nowrap",
          fontSize: 13,
          fontWeight: 500,
          flexShrink: 0,
        }}
      >
        Date range :
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.primary",
          whiteSpace: "nowrap",
          fontWeight: 600,
          fontSize: 13,
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {formattedStartDate && formattedEndDate
          ? `${formattedStartDate} - ${formattedEndDate}`
          : "Select date range"}
      </Typography>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          "& .MuiFormControl-root": {
            width: "100%",
            height: "100%",
            opacity: 0,
          },
          "& .MuiInputBase-root": {
            height: "100%",
            cursor: "pointer",
          },
          "& input": {
            cursor: "pointer",
          },
        }}
      >
        {children || (
          <BSDateRangePicker
            handleStartDate={handleStartDate}
            showToday={showToday}
            triggerDate={triggerDate}
            includeCurrentDate={includeCurrentDate}
            allowFutureDate={allowFutureDate}
            fromDate={fromDate}
            toDate={toDate}
          />
        )}
      </Box>
    </Box>
  );
};



export const ReportSingleDateFilter = ({ date, onDateChange, maxDate }) => {
  const max = maxDate || moment().subtract(1, "days").format("YYYY-MM-DD");
  const inputRef = useRef(null);

  return (
    <Box
      sx={{
        border: "1px solid #00D4AA",
        borderRadius: "8px",
        px: 1.5,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f5f7fa",
        height: 40,
        boxSizing: "border-box",
        gap: 0.5,
        width: "100%",
        cursor: "pointer",
        position: "relative",
      }}
      onClick={() => inputRef.current?.showPicker()}
    >
      <CalendarTodayIcon sx={{ color: "#7c98b6", fontSize: 18, flexShrink: 0, pointerEvents: "none" }} />
      <Typography
        variant="body2"
        sx={{ color: "#7c98b6", whiteSpace: "nowrap", fontSize: 13, fontWeight: 500, flexShrink: 0, pointerEvents: "none" }}
      >
        Date :
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.primary", fontWeight: 600, fontSize: 13, flex: 1, pointerEvents: "none" }}
      >
        {date ? moment(date).format("DD/MM/YYYY") : "Select date"}
      </Typography>
      <input
        ref={inputRef}
        type="date"
        value={date}
        max={max}
        onChange={(e) => {
          if (e.target.value) onDateChange(e.target.value);
        }}
        style={{
          position: "absolute",
          opacity: 0,
          width: "1px",
          height: "1px",
          top: 0,
          left: 0,
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};
